import type { Href } from "expo-router";
import { router } from "expo-router";
import { useEffect } from "react";
import { Text, View } from "react-native";

import { isAdminRole, signOutToHome } from "../../../lib/auth";
import { useAuth } from "../../../lib/authContext";
import { RADII, SPACING, STROKES } from "../../../lib/brand";
import { PANE_THEMES } from "../../../components/brand/paneThemes";
import { AdminButton } from "../../../components/admin/ui";
import { StatusPill } from "../../../components/aspects/StatusPill";

const THEME = PANE_THEMES.Admin;

export default function AdminRejectedScreen() {
  const { user, role, employeeStatus, loading } = useAuth();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      router.replace("/login" as Href);
      return;
    }
    if (!isAdminRole(role)) {
      router.replace("/" as Href);
      return;
    }
    if (employeeStatus !== "rejected") {
      router.replace("/admin" as Href);
      return;
    }
  }, [loading, user, role, employeeStatus]);

  return (
    <View style={{ flex: 1, backgroundColor: THEME.pageBg, alignItems: "center", justifyContent: "center", padding: SPACING.lg }}>
      <View style={{ maxWidth: 420, width: "100%", padding: 24, borderRadius: RADII.lg, backgroundColor: THEME.surfaceRaisedBg, borderWidth: STROKES.hairline, borderColor: THEME.border, gap: 12 }}>
        <Text style={{ fontFamily: THEME.bodyBoldFont, fontSize: 10, letterSpacing: 3, textTransform: "uppercase", color: THEME.accent }}>
          Employee portal
        </Text>
        <Text style={{ fontFamily: THEME.displayMediumFont, fontSize: 24, lineHeight: 28, color: THEME.textOnSurface }}>
          Your access was revoked
        </Text>
        <Text style={{ fontFamily: THEME.bodyFont, fontSize: 13, lineHeight: 19, color: THEME.textOnSurfaceDim }}>
          You cannot use the admin portal. Contact Coravu if you need help.
        </Text>
        <View style={{ flexDirection: "row" }}>
          <StatusPill theme={THEME} label="Access revoked" tone="grey" showDot={false} />
        </View>
        <View style={{ marginTop: 4 }}>
          <AdminButton theme={THEME} label="Sign out" variant="outline" onPress={() => void signOutToHome(router)} />
        </View>
      </View>
    </View>
  );
}
